<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'PolicyHeader',
  inject: ['wp']
}
</script>
